export default "/_next/static/chunks/fonts/HK Grotesk Italic-39c029ecf67854b23b6a9a1f48a7a605.otf";